
// the semi-colon before the function invocation is a safety
// net against concatenated scripts and/or other plugins
// that are not closed properly.
;(function ( $, window, document, undefined ) {

    // undefined is used here as the undefined global
    // variable in ECMAScript 3 and is mutable (i.e. it can
    // be changed by someone else). undefined isn't really
    // being passed in so we can ensure that its value is
    // truly undefined. In ES5, undefined can no longer be
    // modified.

    // window and document are passed through as local
    // variables rather than as globals, because this (slightly)
    // quickens the resolution process and can be more
    // efficiently minified (especially when both are
    // regularly referenced in your plugin).

    // Create the defaults once
    var pluginName = "galleryMockup",
            defaults = {
                    propertyName: "value"
            };

    // The actual plugin constructor
    function Plugin( element, options ) {
            this.element = element;

            // jQuery has an extend method that merges the
            // contents of two or more objects, storing the
            // result in the first object. The first object
            // is generally empty because we don't want to alter
            // the default options for future instances of the plugin
            this.options = $.extend( {}, defaults, options) ;

            this._defaults = defaults;
            this._name = pluginName;

            this.init();
    }

    Plugin.prototype = {

            init: function() {
                    // Place initialization logic here
                    // You already have access to the DOM element and
                    // the options via the instance, e.g. this.element
                    // and this.options
                    // you can add more functions like the one below and
                    // call them like so: this.yourOtherFunction(this.element, this.options).

                    $(this.element).on('click.galleryThumbnail', '.gallery-thumbnail', function(e) {
                            var $this = $(this);
                            var $target = $('#'+$this.data('target'));

                            $this.siblings().removeClass('active');
                            $this.addClass('active');

                            function scrollTo(element, to = 0, duration= 1000, scrollToDone = null) {
                                    const start = element.scrollLeft;
                                    const change = to - start;
                                    const increment = 20;
                                    let currentTime = 0;

                                    const animateScroll = (() => {

                                            currentTime += increment;

                                            const val = Math.easeInOutQuad(currentTime, start, change, duration);

                                            element.scrollLeft = val;

                                            if (currentTime < duration) {
                                                    setTimeout(animateScroll, increment);
                                            } else {
                                                    if (scrollToDone) scrollToDone();
                                            }
                                    });

                                    animateScroll();
                            };

                            Math.easeInOutQuad = function (t, b, c, d) {

                                    t /= d/2;
                                    if (t < 1) return c/2*t*t + b;
                                    t--;
                                    return -c/2 * (t*(t-2) - 1) + b;
                            };

                            var scrollAmount = $this[0].offsetLeft - $this.parent()[0].offsetLeft - ($this.closest('.grid-gallery-thumbnails')[0].clientWidth / 2) + ($this[0].clientWidth / 2) || 0 ;

                            scrollTo($this.closest('.grid-gallery-thumbnails')[0], scrollAmount, 250,  () => {
                                    $target.closest('.gallery-photo').animate({'opacity': 0 }, 250, 'swing', function(){
                                            $target.find('img.image').attr('src', $this.data('src'));
                                            $target.find('.card-text').html($this.data('caption'));
                                            $target.find('.card-byline').html($this.data('byline'));

                                            $target.find('img.image').each(function(ndx) {
                                                    this.onload = function (e) {
                                                            $target.closest('.gallery-photo').animate({'opacity': 1}, 250);
                                                    };
                                            });
                                    });
                                    $this.closest('.gallery-footer').find('.gallery-footer__subnav .count').html('<strong>' + ($this.index()+1) + '</strong>/' + ($this.siblings().length + 1) + '');

                            });
                            //$this.closest('.grid-gallery-thumbnails').animate( { scrollLeft: '-=' + $this[0].offsetLeft - $this.parent()[0].offsetLeft }, 1000, 'easeInOutQuad');

                            // $this.closest('.grid-gallery-thumbnails').scrollLeft($this[0].offsetLeft - $this.parent()[0].offsetLeft - 23);
                            // $this.closest('.grid-gallery-thumbnails').animate( { scrollLeft: '($this[0].offsetLeft - $this.parent()[0].offsetLeft - 23 '});

                    });
                    $(this.element).on('click.galleryThumbnail.prev', '.gallery-prev', function(e) {
                            var $this = $(this);
                            $this.closest('.gallery-footer').find('.gallery-thumbnail.active').prev().trigger('click.galleryThumbnail');
                    });
                    $(this.element).on('click.galleryThumbnail.next', '.gallery-next', function(e) {
                            var $this = $(this);
                            $this.closest('.gallery-footer').find('.gallery-thumbnail.active').next().trigger('click.galleryThumbnail');
                    });
                    $(document).off('keydown.galleryThumbnail.keyboard').on('keydown.galleryThumbnail.keyboard', function(e){
                            switch (e.key) {
                                    case 'ArrowRight':
                                                $('.gallery-next').trigger('click.galleryThumbnail.next');
                                                break;
                                    case 'ArrowLeft':
                                            $('.gallery-prev').trigger('click.galleryThumbnail.prev');
                                            break;

                            }
                    });

                    $(this.element).find('.gallery-thumbnail.active').trigger('click.galleryThumbnail');
            },

            yourOtherFunction: function(el, options) {
                    // some logic
            }
    };

    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function ( options ) {
            return this.each(function () {
                    if (!$.data(this, "plugin_" + pluginName)) {
                            $.data(this, "plugin_" + pluginName,
                                    new Plugin( this, options ));
                    }
            });
    };

})( jQuery, window, document );